var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlob(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5d4f52"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M724 650.5Q598 801 423 742T201.5 466q-46.5-217 188-282.5T737 309q113 191-13 341.5Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: "-50vw",
    y: "-50vh",
    width: "100vw",
    height: "100vh"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "neutral-gray"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: 2.5,
    numOctaves: 100,
    stitchTiles: "stitch",
    result: "noise"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "saturate",
    values: 0,
    result: "destaturatedNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "desaturatedNoise",
    result: "theNoise"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "table",
    tableValues: "0 0 0.3 0"
  })), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "theNoise",
    mode: "soft-light",
    result: "noisy-image"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M724 650.5Q598 801 423 742T201.5 466q-46.5-217 188-282.5T737 309q113 191-13 341.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob);
export default __webpack_public_path__ + "static/media/blob.45b2c43efd12678c392f1a69a536af3b.svg";
export { ForwardRef as ReactComponent };